import React from "react";
import { Box, Heading, Text, Anchor, Button } from "grommet";
export const QuizSummary = ({ numberOfQuestions, onModify, onStart }) => {
  return (
    <Box pad="medium" gap="medium" align="center">
      <Heading level="2">Start your assessment</Heading>

      {/* Assessment settings box */}
      <Box
        pad="medium"
        border={{ color: "brand", size: "small" }}
        round="small"
        width="large"
      >
        <Text>
          <b>Assessment settings</b>
        </Text>
        <Text>Number of questions: {numberOfQuestions}</Text>
        <Text>Duration: {numberOfQuestions} minutes</Text>
      </Box>

      {/* Important Information box */}
      <Box
        pad="medium"
        background="light-2" // Subtle background for emphasis
        round="small"
        width="large"
        border={{ color: "brand", size: "small" }} // Border to highlight this section
      >
        <Heading level="3">
          Important information before starting your assessment
        </Heading>
        <Text margin={{ top: "small" }}>
          <b>1. Be straightforward about your skills:</b> Answer the questions
          accurately based on your current level of knowledge. This ensures we
          provide you with accurate and meaningful insights to support your
          development.
        </Text>
        <Text margin={{ top: "small" }}>
          <b>2. Personalized recommendations:</b> Your responses will generate
          tailored learning paths that align with your current skill level and
          highlight areas for improvement.
        </Text>
        <Text margin={{ top: "small" }}>
          <b>3. Focus on growth:</b> This assessment is a tool for your personal
          and professional development. It’s not a test, but a way to identify
          areas where you can grow and improve
        </Text>
        <Text margin={{ top: "small" }}>
          <b>4. Your privacy matters:</b> Hewlett Packard Enterprise Company and
          its subsidiaries and affiliates respect your privacy. Your responses
          will remain confidential and will only be used to create personalized
          recommendations.{" "}
          <Anchor
            href="https://www.hpe.com/us/en/legal/privacy.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            HPE Privacy Statement
          </Anchor>
        </Text>
      </Box>

      {/* Action buttons */}
      <Box
        direction="row"
        gap="medium"
        justify="center"
        margin={{ top: "medium" }}
      >
        <Button label="Go back and modify" onClick={onModify} />
        <Button
          label="Start your assessment"
          onClick={onStart}
          primary
          // disabled={!termsAccepted}
        />
      </Box>
    </Box>
  );
};
